module.exports = __webpack_public_path__ + "img/recentes-vendas.3aa14e38.svg";